//ALERT/ADVISORY NOTIFICATION POSTS
//*******************************************************************
//*******************************************************************
//Importing Dependencies:
//external and package dependencies 
import React from 'react'
import { Link, graphql } from 'gatsby'
//component dependencies
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import TextBlock from '../../components/textblock'
import FullWidthImage from '../../components/FullWidthImage'
//import PostHeader from '../../components/PostHeader'
import AlertHeader from '../../components/AlertHeader'
import AlertIcon from '../../images/alertIcon.png'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************
class AlertIndex extends React.Component {
    
    render() {
        
        const { data } = this.props
        
        const posts = data.allButterPost.edges
        
        const resultsTable = []
    
        for (var i = 0; i < 190; i++) {

            resultsTable.push(posts[i]);

        };
        
        const alertAdvisory = data.alerts_advisories.edges

        return (

            <div>
            
                
                 <Helmet>
                   <title>NJCCIC Alerts and Advisories</title>
                    <meta name="description" content="Frequently released NJCCIC alerts and advisories on current threats"/>
                </Helmet>
                <Heading/>

                <Navbar/>
            
                {alertAdvisory.map(({ node: { page_title, image, introductory_text } }) => (
                
                    <div class="container-fluid">
            
                        <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>
                        
                        <div class="container containerWidth">
                            
                            <div class="row">
                                
                                <TextBlock elementClass="standardText introPadding alertsIntro btnWidth" text={introductory_text}/>
                                
                            </div>
                            
                        </div>
            
                        <FullWidthImage id="alertsBanner" src={image}/>
            
                    </div>
        
                ))}

                {resultsTable.map(({ node }) => {

                    const postTitle = node.seo_title || node.slug
                    
                    const tag = node.tags

                    return (

                        <div class="container-fluid" key={node.slug}>
                        
                            <div class="row" id="alertsList">
                        
                                <div class="container containerWidth">
                        
                                    <div class="col-12 alertBlock">
                                        
                                        <div class="col-12 iconHeading">
                        
                                            <img class="inline size" src={AlertIcon}/>
                                            
                                            <h2 class="leftHeader clickableHeader iconHeader inline"><Link to={`/alerts-advisories/${node.slug}`}>{postTitle}</Link></h2>
                                            
                                        </div>
                                                                                
                                        <p>{node.summary}</p>
                                        
                                        {tag.map(({ name }) => (
                                        
                                            <p class="postDate"><Link to={`/alerts-advisories/${node.slug}`}>{name} | {node.date}  ></Link></p>
                                        
                                        ))}
                                        
                                        {/*<p>View ></p>*/}
                                        
                                    </div>
                    
                                </div>
                        
                            </div>                        

                        </div>
                        
                    )
                    
                })}   

                <Footer/>

            </div>
            
        )
        
    }
    
}

export default AlertIndex
//*******************************************************************
//*******************************************************************
export const pageQuery = graphql`
 {
  allButterPost(filter: {categories: {elemMatch: {name: {eq: "Alert-Advisory"}}}}) {
    edges {
      node {
        id
        seo_title
        meta_description
        slug
        categories {
          name
          slug
        }
        tags {
          name
          slug
        }
        date
        author {
          first_name
          last_name
          email
          slug
          bio
          title
          linkedin_url
          facebook_url
          instagram_url
          pinterest_url
          twitter_handle
          profile_image
        }
        summary
        body
        featured_image
      }
    }
  }
  alerts_advisories: allButterPage(filter: {slug: {eq: "alerts-advisories"}}) {
    edges {
      node {
        seo_title
        page_title
        introductory_text
        image
        image_alt_text
      }
    }
  }
}
`